"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var instructor_view_student_details_modal_html_1 = __importDefault(require("./instructor-view-student-details-modal.html"));
var instructor_view_student_details_modal_controller_1 = __importDefault(require("./instructor-view-student-details-modal.controller"));
var add_student_modal_controller_1 = __importDefault(require("../../../admin/drives/add-student-modal/add-student-modal.controller"));
var add_student_modal_html_1 = __importDefault(require("../../../admin/drives/add-student-modal/add-student-modal.html"));
var drive_types_1 = require("../../../common/types/drive.types");
var signature_roster_1 = require("../../../common/helpers/signature-roster");
var InstructorDriveController = /** @class */ (function () {
    function InstructorDriveController($uibModal, $state, UserService, $q, $stateParams, UsersModel, DrivesModel, FlashService, PoliciesModel, policyData) {
        var _this = this;
        this.loading = true;
        this.submitting = true;
        this.$uibModal = $uibModal;
        this.UserService = UserService;
        this.$q = $q;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.DrivesModel = DrivesModel;
        this.FlashService = FlashService;
        this.policyData = policyData;
        this.PoliciesModel = PoliciesModel;
        this.drive = {};
        this.pickuplocation = {};
        this.dropofflocation = {};
        this.pickuplocations = [];
        this.dropofflocations = [];
        this.addingStudent = false;
        this.canViewStudentOrders = false;
        this.canBookDrivingLessons = false;
        this.canCancelDrivingLessons =
            policyData.AllowInstructorsToCancel.FeatureEnabled;
        this.instructor = UserService.getCurrentUser();
        this.canGrade = false;
        this.cannotGradeMessage = "";
        this.useReportCards = false;
        this.instructorSigned = false;
        this.setup = this.setup.bind(this);
        this.removePassenger = this.removePassenger.bind(this);
        this.updateSession = this.updateSession.bind(this);
        this.bookObservationSlot = this.bookObservationSlot.bind(this);
        this.sessionBooked = this.sessionBooked.bind(this);
        this.saveSignature = this.saveSignature.bind(this);
        this.setup()
            .then(function (response) {
            _this.loading = false;
        })
            .catch(function (Error) {
            console.error(Error);
            _this.loading = false;
        });
    }
    InstructorDriveController.prototype.sessionBooked = function () {
        if (this.drive.observation === false) {
            return this.drive.student_id !== null;
        }
        return this.drive.students.length > 0;
    };
    /**
     * Whether to prompt the instructor to sign this completed lesson. The
     * roster's instructor row is lesson-wide, so this reads the same on a
     * single-student lesson and an observation.
     */
    InstructorDriveController.prototype.showSignaturePad = function () {
        return (this.drive.status === "Complete" &&
            !this.instructorSigned &&
            (this.drive.signature_roster || []).some(function (row) { return row.signee_type === "instructor" && row.status === "awaiting"; }));
    };
    InstructorDriveController.prototype.saveSignature = function (signature) {
        var _this = this;
        this.DrivesModel.submitDriveSignature(this.drive.id, signature, "instructor").then(function (response) {
            _this.instructorSigned = true;
            _this.drive.signature_roster = (0, signature_roster_1.markRosterRowSigned)(_this.drive.signature_roster, function (row) { return row.signee_type === "instructor"; }, signature);
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        }, function () {
            _this.FlashService.setMessage({
                type: "danger",
                message: "We were unable to save your signature. Please try again or contact your driving school.",
            });
        });
    };
    InstructorDriveController.prototype.resetAddingStudent = function () {
        this.pickuplocations = [];
        this.pickuplocation = {};
        this.dropofflocations = [];
        this.dropofflocation = {};
        this.addingStudent = false;
        delete this.drive.student;
        this.drive.student_id = null;
    };
    InstructorDriveController.prototype.setpolicies = function (response) {
        this.school = response.school;
    };
    InstructorDriveController.prototype.getStudentAge = function (dob) {
        var birthday = new Date(dob);
        var today = new Date();
        var age = today.getFullYear() - birthday.getFullYear();
        var monthDiff = today.getMonth() - birthday.getMonth();
        if (monthDiff < 0 ||
            (monthDiff === 0 && today.getDate() < birthday.getDate())) {
            age--;
        }
        return age;
    };
    InstructorDriveController.prototype.setdrive = function (response) {
        this.drive = response.drive;
        if (this.drive.status !== "Available") {
            if (this.drive.student_id !== null) {
                var hasGuardian = this.drive.student.usermeta.filter(function (meta) {
                    return meta.meta_key === "guardian";
                });
                var parentMeta = void 0;
                if (hasGuardian.length === 1) {
                    parentMeta = hasGuardian[0].meta_value;
                    this.drive.student.guardian = JSON.parse(parentMeta);
                }
                this.drive.student.phone = this.drive.student.usermeta.filter(function (meta) {
                    return meta.meta_key === "phone";
                })[0].meta_value;
                var dob_meta = this.drive.student.usermeta.find(function (meta) { return meta.meta_key === "dob"; });
                if (dob_meta) {
                    this.drive.student.dob = dob_meta.meta_value;
                }
                else {
                    this.drive.student.dob = "";
                }
                var pronoun_meta = this.drive.student.usermeta.find(function (meta) { return meta.meta_key === "preferred_pronoun"; });
                if (pronoun_meta) {
                    this.drive.student.preferred_pronoun = pronoun_meta.meta_value;
                }
                else {
                    this.drive.student.preferred_pronoun = "";
                }
            }
            else {
                if (this.drive.observation === true) {
                    this.drive.students = this.drive.students.map(function (student) {
                        var hasGuardian = student.usermeta.filter(function (meta) {
                            return meta.meta_key === "guardian";
                        });
                        var parentMeta;
                        if (hasGuardian.length === 1) {
                            parentMeta = hasGuardian[0].meta_value;
                            student.guardian = JSON.parse(parentMeta);
                        }
                        student.phone = student.usermeta.filter(function (meta) {
                            return meta.meta_key === "phone";
                        })[0].meta_value;
                        var dob_meta = student.usermeta.find(function (meta) { return meta.meta_key === "dob"; });
                        if (dob_meta) {
                            student.dob = dob_meta.meta_value;
                        }
                        else {
                            student.dob = "";
                        }
                        var pronoun_meta = student.usermeta.find(function (meta) { return meta.meta_key === "preferred_pronoun"; });
                        if (pronoun_meta) {
                            student.preferred_pronoun = pronoun_meta.meta_value;
                        }
                        else {
                            student.preferred_pronoun = "";
                        }
                        return student;
                    });
                }
            }
        }
        // Observation drives expose their slots as drives_students pivot rows; an
        // open slot is one with no student_id yet. Surface those so instructors can
        // book a student into a specific slot.
        if (this.drive.observation === true) {
            this.drive.openSlots = (this.drive.slots || [])
                .filter(function (slot) { return !slot.student_id; })
                .map(function (slot) { return ({
                id: slot.id,
                windowStart: (0, time_1.dateTimeStringToDate)(slot.start),
                windowEnd: (0, time_1.dateTimeStringToDate)(slot.end),
            }); });
        }
        Object.assign(this.drive, (0, drive_types_1.formatDriveForDisplay)(this.drive));
        this.driveDate = new Date(this.drive.drive_date + " " + this.drive.start_time);
        this.endTimeMoment = (0, time_1.addMinutes)(this.driveDate, this.drive.session_length);
        var now = new Date();
        var diffDays = (0, time_1.differenceInDays)(this.driveDate, now);
        if (diffDays === 0) {
            this.untilDrive = "today";
        }
        else if (diffDays === 1) {
            this.untilDrive = "tomorrow";
        }
        else if (diffDays > 0) {
            this.untilDrive = "in ".concat(diffDays, " days");
        }
        else {
            this.untilDrive = "".concat(Math.abs(diffDays), " days ago");
        }
    };
    /**
     * Set up the policies and drive data for the view
     */
    InstructorDriveController.prototype.setup = function () {
        var _this = this;
        var getSettings = this.PoliciesModel.getByID("studentmetadata");
        var getDrive = this.DrivesModel.getDriveByID(this.$stateParams.driveId);
        return this.$q.all([getSettings, getDrive]).then(function (responses) {
            var settings = responses[0];
            var drive = responses[1];
            _this.preferred_pronoun_enabled = false;
            var policyMeta = {};
            settings.policy.policymeta.forEach(function (meta) {
                policyMeta[meta.meta_key] = meta.meta_value;
            });
            if (policyMeta.preferred_pronoun) {
                _this.preferred_pronoun_enabled = true;
            }
            if (_this.policyData.InstructorCanViewStudentOrders.FeatureEnabled) {
                _this.canViewStudentOrders = true;
            }
            if (_this.policyData.InstructorCanBookDrivingLessons.FeatureEnabled) {
                _this.canBookDrivingLessons = true;
            }
            if (_this.policyData.UseReportCards.FeatureEnabled) {
                _this.useReportCards = true;
            }
            _this.setdrive(drive);
            // if (this.policyData.AllowGradeDuringDrive.FeatureEnabled && this.drive.inProgress) {
            //     this.canGrade = true;
            // } else {
            //     this.canGrade = false;
            // }
            // if (vm.sessionBooked() && isAfter(new Date(), this.endTimeMoment)) {
            //     this.canGrade = true;
            // } else {
            //     this.cannotGradeMessage = 'You cannot grade this driving lesson because it is booked and it is not after the end of the driving lesson.'
            //     this.canGrade = false;
            // }
            if (_this.policyData.AllowGradeDuringDrive.FeatureEnabled === true) {
                if (_this.sessionBooked() && (0, time_1.isBefore)(_this.driveDate, new Date())) {
                    _this.canGrade = true;
                }
                else {
                    _this.cannotGradeMessage =
                        "You cannot grade this driving lesson because it has not started.";
                    _this.canGrade = false;
                }
            }
            else {
                if (_this.sessionBooked() && (0, time_1.isBefore)(_this.endTimeMoment, new Date())) {
                    _this.canGrade = true;
                }
                else {
                    _this.cannotGradeMessage =
                        "You cannot grade this driving lesson because the lesson has not ended.";
                    _this.canGrade = false;
                }
            }
            return _this.drive;
        });
    };
    InstructorDriveController.prototype.showGradeAndCancelOptions = function () {
        var hasStudent;
        if (this.drive.observation === false) {
            hasStudent = this.drive.student_id !== null;
        }
        else {
            hasStudent = this.drive.students.length > 0;
        }
        var inProgressOrUngradedInPast = this.drive.inProgress ||
            (this.drive.status !== "Complete" && this.drive.inPast);
        return hasStudent && inProgressOrUngradedInPast;
    };
    InstructorDriveController.prototype.removePassenger = function (index) {
        this.drive.students.splice(index, 1);
    };
    InstructorDriveController.prototype.viewStudentDetails = function () {
        var _this = this;
        var modalInstance = this.$uibModal.open({
            animation: true,
            template: instructor_view_student_details_modal_html_1.default,
            controller: instructor_view_student_details_modal_controller_1.default,
            controllerAs: "vm",
            size: "md",
            resolve: {
                student: function () { return _this.drive.student; },
                preferred_pronoun_enabled: function () { return _this.preferred_pronoun_enabled; },
            },
        });
        modalInstance.result.then(function (cancellation) {
            // $scope.selected = selectedItem;
        }, function () { });
    };
    InstructorDriveController.prototype.viewStudentOrders = function (studentId) {
        this.$state.go("drivecoach.instructor.dashboard.studentorders", {
            student_id: studentId,
        });
    };
    InstructorDriveController.prototype.viewStudentNotes = function (studentId) {
        this.$state.go("drivecoach.instructor.dashboard.studentnotes", {
            userId: studentId,
        });
    };
    /**
     * Add student modal
     */
    InstructorDriveController.prototype.addStudentModal = function (slot) {
        var _this = this;
        if (slot === void 0) { slot = null; }
        var drive = Object.assign({}, this.drive, {
            start_time: (0, time_1.timeStringToDate)(this.drive.start_time),
        });
        var modalInstance = this.$uibModal.open({
            animation: true,
            template: add_student_modal_html_1.default,
            controller: add_student_modal_controller_1.default,
            controllerAs: "vm",
            size: "lg",
            resolve: {
                drivesession: function () { return drive; },
                toggleStudentSchoolOverride: function () { return false; },
                // Pre-selected when an instructor books a specific open observation
                // slot; null for a regular single-student drive.
                preselectedSlot: function () { return slot; },
            },
        });
        modalInstance.result.then(function (data) {
            if (_this.drive.observation === false) {
                _this.drive = data.drivesession;
                _this.drive.student_id = data.drivesession.student.id;
                _this.drive.status = "Taken";
                _this.loading = true;
                _this.UsersModel.getPickupLocations(_this.drive.student_id)
                    .then(function (response) {
                    _this.pickuplocations = [].concat(response.pickuplocations);
                    _this.dropofflocations = [].concat(response.pickuplocations);
                    _this.loading = false;
                    _this.addingStudent = true;
                })
                    .catch(function (Error) {
                    _this.loading = false;
                    _this.addingStudent = false;
                });
            }
            else {
                // The modal added the student to the slot we passed in; persist that
                // single claim and refetch to reflect the new booking.
                var claimed = data.drivesession.students.find(function (student) { return slot && student.slotId === slot.id; });
                if (claimed) {
                    _this.bookObservationSlot(claimed);
                }
            }
        });
    };
    /**
     * Claim a single open observation slot for the chosen student. The backend's
     * claim endpoint takes the slot's admin-defined window as the source of truth
     * and forces pickup/dropoff to the drive's location for observation drives.
     */
    InstructorDriveController.prototype.bookObservationSlot = function (student) {
        var _this = this;
        this.submitting = true;
        var locationId = (this.drive.location && this.drive.location.id) || this.drive.location_id;
        var data = {
            drive_id: this.drive.id,
            student_id: student.id,
            slot_id: student.slotId,
            observer_or_driver: student.observer_or_driver,
            pickuplocation: { id: locationId },
            dropofflocation: { id: locationId },
        };
        this.DrivesModel.claimDrive(data)
            .then(function (response) {
            return _this.DrivesModel.getDriveByID(_this.drive.id).then(function (drive) {
                _this.setdrive(drive);
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.submitting = false;
            });
        })
            .catch(function (error) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                type: "warning",
                message: (error && error.data && error.data.message) ||
                    "Unable to book that slot. Please try again.",
            });
        });
    };
    InstructorDriveController.prototype.updateSession = function () {
        var _this = this;
        this.submitting = true;
        var data = {
            drive_id: this.drive.id,
            student_id: this.drive.student.id,
            pickuplocation: this.pickuplocation,
            dropofflocation: this.dropofflocation,
        };
        this.DrivesModel.claimDrive(data).then(function (response1) {
            _this.DrivesModel.getDriveByID(_this.drive.id)
                .then(function (response) {
                _this.setdrive(response);
                _this.FlashService.setMessage({
                    type: "success",
                    message: response1.message,
                });
                _this.addingStudent = false;
                _this.submitting = false;
            })
                .catch(function (Error) {
                _this.addingStudent = false;
                _this.submitting = false;
            });
        });
    };
    InstructorDriveController.prototype.cleanGeom = function (sector) {
        delete sector.geom;
        return sector;
    };
    return InstructorDriveController;
}());
InstructorDriveController.$inject = [
    "$uibModal",
    "$state",
    "UserService",
    "$q",
    "$stateParams",
    "UsersModel",
    "DrivesModel",
    "FlashService",
    "PoliciesModel",
    "policyData",
];
exports.default = InstructorDriveController;
